import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { automationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useDeleteAutomation = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();
  const { t } = useTranslation();

  return useMutation(code => automationServices.delete(code), {
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['automations'] });
      showSuccess({
        message: t('xDeletedSuccessfully', { type: t('automation') }),
        type: 'toast'
      });
    }
  });
};
